import { render, staticRenderFns } from "./WalletCharge.vue?vue&type=template&id=54b859a1&scoped=true"
import script from "./WalletCharge.vue?vue&type=script&lang=js"
export * from "./WalletCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b859a1",
  null
  
)

export default component.exports